import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ProfileContainer = styled(Box)(({ theme }) => ({
  display: 'flex', 
  alignItems: 'center', 
  gap: 0.5
}));
